import { atom } from 'jotai'

export const activeNameAtom = atom('')
